module.exports = __webpack_public_path__ + "img/build-a-flow.32e409a6.svg";